import { tsValidateValue } from '@nu-art/ts-common';
import { AIPromptTypes } from './types.js';
export const Validator_AIPromptType = tsValidateValue(AIPromptTypes);
//# sourceMappingURL=validation.js.map